import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dropbox-welcome',
  templateUrl: './dropbox-welcome.component.html',
  styleUrls: ['./dropbox-welcome.component.css']
})
export class DropboxWelcomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
